// Package imports:
import React from 'react';
import cx from 'classnames';

type DisplayBoxSize = 'sm' | 'lg';

type DisplayBoxDivProps = React.HTMLAttributes<HTMLDivElement>;
type AnchorProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;

interface IOwnProps {
    title?: string,
    statusComponent?: JSX.Element,
    asideComponent?: JSX.Element,
    displayBoxSize?: DisplayBoxSize,
    anchorProps?: AnchorProps,
    titleComponent?: JSX.Element,
    description?: JSX.Element,
    grayBackground?: boolean
}

type Props = DisplayBoxDivProps & IOwnProps;

const DisplayBox: React.FC<Props> = ({
    title,
    statusComponent,
    children,
    asideComponent,
    displayBoxSize = 'lg',
    anchorProps,
    titleComponent,
    className,
    description,
    grayBackground = false,
    ...props
}) => {
    const wrapWithAnchor = (component: string | JSX.Element | undefined) => {
        if(anchorProps) {
            return (
                <a {...anchorProps}>
                    {component}
                </a>
            );
        }
        return component;
    }
    return (
        <div className={cx("display-box", displayBoxSize, className, {'gray-background': grayBackground})} {...props}>
            {(title || titleComponent || asideComponent) &&
                <div className={cx("display-box__head", {'noMarginBottom': description})}>
                    {displayBoxSize === 'sm'
                            ? <h5 className="h5">
                                {wrapWithAnchor(title ?? titleComponent)}
                                {statusComponent}
                            </h5>
                            : <h4 className="h4">
                                {wrapWithAnchor(title ?? titleComponent)}
                                {statusComponent}
                            </h4>
                    }

                    {asideComponent && (
                        <div className="display-box__head-aside">
                            {asideComponent}
                        </div>
                    )}
                </div>
            }
            {description && description}

            <div className="display-box__body">
                {children}
            </div>
        </div>
    )
}

export default DisplayBox
